import { render, staticRenderFns } from "./ExtraBalls.vue?vue&type=template&id=096c79ec&"
import script from "./ExtraBalls.vue?vue&type=script&lang=js&"
export * from "./ExtraBalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports